import { ConfirmAccountWithoutPasswordDto, ProfileClient } from '../api/client';
import { IEventHandler } from '../infrastructure';
import { IAuthClient} from './auth-client';
import { handleErrorAction} from '../app/errorHandling';
import { Infrastructure } from '../index';

class AuthService {
  public refreshTask: Promise<boolean> = Promise.resolve(false);

  private readonly eventHandler: IEventHandler;
  private readonly loginClient: IAuthClient;
  private readonly profileClient: ProfileClient;

  constructor(eventHandler: IEventHandler, loginClient: IAuthClient, profileClient: ProfileClient) {
    this.eventHandler = eventHandler;
    this.loginClient = loginClient;
    this.profileClient = profileClient;
  }

  public async confirmAccount(userId: string | undefined, code: string | undefined): Promise<void> {
    Infrastructure.logger().info(`Confirming account`);

    if (!userId || !code) {
      throw new Error('Login_ConfirmEmail_EmptyEmailOrCode');
    }
    await this.profileClient.confirmWithoutPassword(
      new ConfirmAccountWithoutPasswordDto({
        code: code,
        userSubject: userId,
      })
    );
  }

  public async resendConfirmation(email: string): Promise<void> {
    await this.loginClient.resendConfirmation(email);
  }
  public async resendConfirmationForCurrentUser(): Promise<void> {
    try {
      await this.loginClient.resendConfirmationForCurrentUser();
    } catch (error: any) {
      this.eventHandler.handleRootAction(handleErrorAction(error.message || error.toString()));
      throw error;
    }
  }

  public async forgotPassword(email: string): Promise<void> {
    Infrastructure.logger().info(`Forgot password procedure has been activated`);

    if (!email) {
      throw new Error('Login_ForgotPassword_EmptyEmail');
    }

    await this.loginClient.forgotPassword(email);
  }

  public async resetPassword(email: string | undefined , password: string | undefined , code: string | undefined ): Promise<void> {
    Infrastructure.logger().info(`User have just set up new password`);

    if (!email || !code) {
      throw new Error('Login_ConfirmEmail_EmptyEmailOrCode');
    }

    if (!password) {
      throw new Error('Login_ResetPassword_EmptyPassword');
    }

    await this.loginClient.resetPassword(email, password, code);
  }

  public async confirmChangeEmail(userId: string | undefined, email: string | undefined, code: string | undefined): Promise<void> {
    Infrastructure.logger().info('Confirming changed email');

    if (!email || !code || !userId) {
      throw new Error('Login_ConfirmEmail_EmptyEmailOrCode')
    }

    await this.loginClient.confirmChangeEmail(userId, email, code);
  }

}

export default AuthService;
